export function toSentenceCase(input) {
  return input
    .toLowerCase() // convert to lowercase
    .replace(/_/g, " ") // replace underscores with spaces
    .replace(/(^\w|\s\w)/g, (c) => c.toUpperCase()); // capitalize first letter of each word
}

export const truncateText = (word, length = 23) => {
  if (typeof word !== 'string') return '';
  
  return word.length > length 
    ? `${word.slice(0, length)}...` 
    : word;
};